import { CLINIC, callLink, waLink } from "../data/clinic";
import { useLang } from "../i18n/LanguageContext";
import { MessageCircle, Phone } from "lucide-react";

export default function FloatingActions() {
  const { lang } = useLang();
  return (
    <div className="fixed bottom-5 right-5 z-40 flex flex-col gap-3">
      <a
        href={callLink}
        data-testid="floating-call-btn"
        aria-label={`Call ${CLINIC.phone}`}
        className="flex h-14 w-14 items-center justify-center rounded-full bg-brand-primary text-white shadow-lg shadow-brand-primary/30 transition-transform duration-300 hover:-translate-y-1"
      >
        <Phone className="h-6 w-6" strokeWidth={1.75} />
      </a>
      <a
        href={waLink(null, lang)}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-btn"
        aria-label="Book appointment on WhatsApp"
        className="relative flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-[#25D366]/30 transition-transform duration-300 hover:-translate-y-1"
      >
        <span className="absolute inset-0 animate-ping rounded-full bg-[#25D366] opacity-30" />
        <MessageCircle className="relative h-6 w-6" strokeWidth={1.75} />
      </a>
    </div>
  );
}
